<div *ngIf="user">
<h2 class="text-center"> Editing Access Information for {{user['email']}}</h2>
<app-spinner *ngIf="isSaving"></app-spinner>
<app-error *ngIf="errorSaving"></app-error>

<table class="table">
  <thead>
    <th></th>
    <th></th>
  </thead>
  <tbody>
    <tr>
      <td>First name</td><td>{{user.firstname}}</td>
    </tr>
    <tr>
      <td>Last Name</td><td>{{user.lastname}}</td>
    </tr>
  </tbody>
</table>

<div class="text-center mt-2 mb-2">
  <a [routerLink]="['/user/general/edit',user.server_user_id]" class="btn btn-primary me-2">Edit General Info</a>
  <a [routerLink]="['/user/password/edit',user.server_user_id]" class="btn btn-primary me-2">Edit Password Info</a>
</div>
<div *ngIf="update_success" class="alert alert-info text-center mb-3"> Update Success</div>



<form [formGroup]="userEditForm" (ngSubmit)="on_submit()" *ngIf="user.server_user_id!=0">
  <div *ngFor="let gg of roleGroups;"  class="form-group row">
    <hr/>
    <div class="col-md-6 text-right" >
        <input type="checkbox" formcontrolName="rgName"
            [checked]="isChecked(gg)"
            [value]="gg['id']"
            (change)="onCheck(gg['id'])">
    </div>
    <label for="rgName" class='control-label col-md-6 text-left'>{{gg['name']}} </label>

</div>

  <fieldset class="buttons text-center">
    <button type="submit" class="btn btn-primary margin-50-right">Submit</button>
    <a *ngIf="gatePass.is_role_guardian" [routerLink]="['/guardian/show',guardian.server_user.server_user_id]"
      class="btn btn-danger" data-dismiss="modal">Close
    </a>
    <a *ngIf="gatePass.is_role_admin" [routerLink]="['/home/admin/show']" class="btn btn-danger">Close</a>
  </fieldset>
</form>
</div>
